<template>
    <section class="chat_bot_sec">
        <div class="container padding_remove_cl">
            <div class="user-chat w-100">
                <div class="d-lg-flex">
                    <!-- start chat conversation section -->
                    <div class="w-100 position-relative chatUI-fix">
                        <div class="p-3 p-lg-4 border-bottom user-chat-topbar chatUI-header">
                            <div class="row align-items-center">
                                <div class="col-sm-4 col-8">
                                    <div class="d-flex align-items-center">
                                        <div class="me-3 ms-0">
                                            <div class="avatar-sm">
                                                <span class="avatar-title rounded-circle letter-wise-cricle">
                                                    C
                                                </span>
                                                <span class="user-status"></span>
                                            </div>
                                        </div>
                                        <div class="flex-grow-1 overflow-hidden typing">
                                            <h5 class="font-size-16 mb-0 text-truncate">
                                                <a href="#" class="text-reset user-profile-show">Customer Support </a> <i class="ri-record-circle-fill font-size-10 text-success d-inline-block ms-1"></i>
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-8 col-4">
                                    <ul class="list-inline user-chat-nav text-end mb-0">
                                        <li class="list-inline-item">
                                            <div class="dropdown">
                                                <button class="btn btn-danger" @click="$router.back()">Close</button>
                                                <!-- <button class="btn nav-btn dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                    <i class="ri-more-fill"></i>
                                                </button>
                                                <div class="dropdown-menu dropdown-menu-end">
                                                    <a class="dropdown-item" href="#">Delete Chat <i class="ri-delete-bin-line float-end text-muted"></i></a>
                                                </div> -->
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <!-- end chat user head -->

                        <!-- start chat conversation -->
                        <div class="chat-conversation p-3 p-lg-4 chatUI-body" data-simplebar="init">
                            <ul class="list-unstyled mb-0 chat-list-container" ref="messagesListSec" @scroll="infiniteScroll">
                                <template v-for="(chat, index) in chatList" :key="index">
                                    <li>
                                        <div class="chat-day-title" v-if="chat.showChangeDate">
                                            <span class="title">{{ $dateTime.sportItemDate(chat.created_at, 'D-M-YYYY') }}</span>
                                        </div>
                                    </li>
                                    <li v-if="(chat.from_user == clientParentId)">
                                        <div class="conversation-list">
                                            <div class="ctext-wrap-content" v-if="chat.is_file === 0">
                                                <p class="mb-0">
                                                    {{ chat.message }}
                                                </p>
                                                <p class="chat-time mb-0"><span class="align-middle">{{ $dateTime.sportItemDate(chat.created_at, 'h:mm A') }}</span></p>
                                            </div>
                                            <div class="ctext-wrap-content" v-if="chat.is_file === 1">
                                                <ul class="list-inline message-img mb-0">
                                                    <li class="list-inline-item message-img-list me-2 ms-0">
                                                        <div>
                                                            <a class="popup-img d-inline-block m-1" :href="chat.message" target="_blank">
                                                                <img :src="chat.message" class="img-fluid chat-image"  />
                                                            </a>
                                                        </div>

                                                    </li>
                                                </ul>
                                                <p class="chat-time mb-0"><span class="align-middle">{{ $dateTime.sportItemDate(chat.created_at, 'h:mm A') }}</span></p>
                                            </div>
                                            <div class="ctext-wrap-content" v-if="chat.is_file === 2">
                                                <div class="message-audio-bx">
                                                    <audio controls controlsList="nodownload">
                                                        <source :src="chat.message" type="audio/mpeg" />
                                                        Your browser does not support the audio element.
                                                    </audio>
                                                </div>
                                                <p class="chat-time mb-0"><span class="align-middle">{{ $dateTime.sportItemDate(chat.created_at, 'h:mm A') }}</span></p>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="right" v-else>
                                        <div class="conversation-list">
                                            <div class="user-chat-content">
                                                <div class="ctext-wrap">
                                                    <div class="ctext-wrap-content" v-if="chat.is_file === 0">
                                                        <p class="mb-0">
                                                            {{ chat.message }}
                                                        </p>
                                                        <p class="chat-time mb-0"><span class="align-middle">{{ $dateTime.sportItemDate(chat.created_at, 'h:mm A') }}</span></p>
                                                    </div>
                                                    <div class="ctext-wrap-content" v-if="chat.is_file === 1">
                                                        <ul class="list-inline message-img mb-0">
                                                            <li class="list-inline-item message-img-list me-2 ms-0">
                                                                <div>
                                                                    <a class="popup-img d-inline-block m-1" :href="chat.message" target="_blank">
                                                                        <img :src="chat.message" class="img-fluid chat-image"  />
                                                                    </a>
                                                                </div>

                                                            </li>
                                                        </ul>
                                                        <p class="chat-time mb-0"><span class="align-middle">{{ $dateTime.sportItemDate(chat.created_at, 'h:mm A') }}</span></p>
                                                    </div>
                                                    <div class="ctext-wrap-content" v-if="chat.is_file === 2">
                                                        <div class="message-audio-bx">
                                                        <audio controls controlsList="nodownload">
                                                            <source :src="chat.message" type="audio/mpeg" />
                                                            Your browser does not support the audio element.
                                                            </audio>
                                                        </div>
                                                        <p class="chat-time mb-0"><span class="align-middle">{{ $dateTime.sportItemDate(chat.created_at, 'h:mm A') }}</span></p>
                                                    </div>

                                                    <!-- <div class="dropdown align-self-start">
                                                        <a class="dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                            <i class="ri-more-2-fill"></i>
                                                        </a>
                                                        <div class="dropdown-menu">
                                                            <a class="dropdown-item" @click="editMessage(chat, index)" v-if="chat.is_file != 1 && chat.is_file != 2" href="javascript:void(0)">Edit <i class="ri-edit-2-line float-end text-muted"></i></a>
                                                            <a class="dropdown-item"  @click="deleteMessage(chat, index)" href="javascript:void(0)" data-bs-toggle="modal" data-bs-target="#want-delete-chat-modal">Delete <i class="ri-delete-bin-line float-end text-muted"></i></a>
                                                        </div>
                                                    </div> -->
                                                </div>

                                                <div class="conversation-name"></div>
                                            </div>
                                        </div>
                                    </li>
                                </template> 
                            </ul>
                        </div>
                        <!-- end chat conversation end -->

                        <!-- image previw -->
                         <div class="chatUI-footer">
                            <div class="cb-mess-img-preview-footer" v-if="selectedImage" id="image-preview">
                                <div class="cb-mess-img-preview-box">
                                    <img :src="selectedImage" class="img-fluid rounded-circle selected-image" width="200" />
                                    <i class="fa-solid fa-circle-xmark close-img-btn" @click="closePreview()"></i>
                                </div>
                            </div>

                            <!-- start chat input section -->
                            <div class="chat-input-section p-3 p-lg-4 border-top mb-0" v-if="isEditing">
                                <div class="row g-0">
                                    <div class="col">
                                        <div class="bottom-input-attach-btn">
                                            <input type="text" v-model="message"  class="form-control form-control-lg bg-light border-light" @keyup.enter="sendEditMessage()" v-on:keyup="checkMessageEdit()"  placeholder="Enter Message..." />
                                        </div>
                                    </div>

                                    <div class="col-auto">
                                        <div v-if="cancelEditing">
                                            <span class="send-message-btn">&nbsp;
                                                <button class="btn btn-primary chat-send-btn font-size-16 btn-lg chat-send" @click="cancelEdit()">
                                                    <i class="fa fa-times" aria-hidden="true"></i>
                                                </button>
                                            </span>
                                        </div>
                                        <div v-else>
                                            <span class="send-message-btn" v-if="isSending">&nbsp;
                                                <button class="btn btn-primary font-size-16 btn-lg chat-send chat-send-btn">
                                                    <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
                                                </button>
                                            </span>
                                            <span class="send-message-btn" v-else>
                                            &nbsp;
                                                <button class="btn btn-primary chat-send-btn font-size-16 btn-lg chat-send" @click="sendEditMessage()">
                                                    <i class="ri-send-plane-2-fill"></i>
                                                </button>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-else class="chat-input-section p-3 p-lg-4 border-top mb-0">
                                <div class="row g-0">
                                    <div class="col">
                                        <div class="bottom-input-attach-btn">
                                            <div data-bs-toggle="tooltip" data-bs-placement="left" title="Attachment" class="attach-btn">
                                                <input @change="showPreview" type="file" ref="file" accept="image/png, image/jpeg, image/jpg" style="display: none;" />
                                                <button  @click="(event) => selectFile(event)" type="button" class="btn btn-link text-decoration-none font-size-16 btn-lg attached-btn">
                                                    <i class="ri-attachment-line"></i>
                                                </button>
                                            </div>
                                            <input type="text"  v-model="userFileName"  class="form-control form-control-lg bg-light border-light" placeholder="Enter Message..."  readonly v-if="readOnlyField"/>
                                            <input type="text"  v-model="message" :disabled="isSending==true" class="form-control form-control-lg bg-light border-light" @keyup.enter="sendMessage()" v-on:keyup="checkMessageText()" placeholder="Enter Message..." v-else />
                                        </div>
                                    </div>
                                    <div class="col-auto">
                                        <div v-if="isSending" class="chat-input-links ms-md-2 me-md-0">
                                            <button class="btn btn-primary font-size-16 btn-lg chat-send chat-send-btn">
                                                <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
                                            </button>
                                        </div>
                                        <div v-else class="chat-input-links ms-md-2 me-md-0" data-bs-toggle="tooltip" data-bs-placement="left" title="Audio">
                                            <div @click="sendMessage()" v-if="isTextMessage">
                                                <button class="btn btn-primary chat-send-btn font-size-16 btn-lg chat-send">
                                                    <i class="ri-send-plane-2-fill"></i>
                                                </button>
                                            </div>
                                            <button v-else type="submit" class="btn btn-primary font-size-16 btn-lg chat-send-btn" data-bs-toggle="modal" data-bs-target="#add-audio-modal">
                                                <i class="ri-mic-fill"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- end chat input section -->
                    </div>
                    <!-- end chat conversation section -->
                </div>
                <!-- End User chat -->
            </div>
        </div>
    </section>
    <!-- add-audio-modal Modal -->
    <ChatAudio :rec="rec" :isSending="isSending"
        @send-audio-message="sendMessage"/>
</template>

<script>
import socketService from '@/socket/sport-socket-service';
import { defineAsyncComponent } from 'vue';
export default {
    name: 'ChatComponent',
    components:{
        ChatAudio: defineAsyncComponent(() =>
            import('../components/ChatAudio.vue')
        )
    },
    data() {
        return {
            clientParentId: null,
            chatList: [],
            isTextMessage: false,
            userFileName: "",
            selectedImage: "",
            readOnlyField: false,
            userFile: "",
            message: "",
            isEditing: false,
            isSending: false,
            cancelEditing: true,
            rec: "",
            chatPage: 1,
            tempChatDate: null
        }
    },
    created() {
        this.clientParentId = this.$auth?.user?.cpi
        this.getChats()
    },
    mounted(){
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
            navigator.mediaDevices.getUserMedia({ audio: true })
                .then((stream) => {
                    this.handlerFunction(stream);
                })
                .catch((err) => {
                    console.error("Error accessing audio stream:", err);
                });
        } else {
            console.error("getUserMedia is not supported in this browser.");
            // this.$errorToast("Audio recording is not supported in your browser.");
        };
        this.startChatSocket();
    },
    methods: {
        startChatSocket() {
            socketService.emit("sub", `userChat-${this.$auth.user.userid}`)
            socketService.on("sendmessage", (chatData) => {
                this.chatList.push(chatData);
                this.scrollToBottom();
            });
        },
        getChats(isInfinite = false) {
            if(isInfinite) {
                this.chatPage += 1 
            }
            this.$apiCall('get', 'GET_CHAT_LIST', null, 'user', {id: this.clientParentId, page: this.chatPage}).then(response => {
                if (response?.status == 200) {
                    if (response?.data?.error) {
                        this.$errorToast(response.data.error);
                    }
                    else {
                        this.chatList = [...this.chatList, ...response.data.data.data];
                        this.chatList.forEach(item => {
                            item.showChangeDate = groupByDate(chat.created_at) ? true : false;
                        });
                        if(!isInfinite) {
                            this.scrollToBottom();
                        }
                    }
                }
            }).catch(error => {
                if (error) {
                    this.$errorToast(error[0]);
                }
            });
        },
        scrollToBottom() {
            this.$nextTick(() => {
                const messageList = this.$refs.messagesListSec;
                if (messageList) {
                    messageList.scrollTop = messageList.scrollHeight;
                }
            });
        },
        async infiniteScroll() {
            const messagesListSec = this.$refs.messagesListSec;
            const atTop = messagesListSec?.scrollTop === 0;
            if (atTop){
                this.getChats(true);
            }
        },
        selectFile(event) {
            var fileInputElement = this.$refs.file;
            fileInputElement.click();
            this.showPreview(event);
        },
        showPreview(event) {
            this.message = "";
            var input = event.target;
            if (input.files) {
                this.isTextMessage = true;
                var reader = new FileReader();
                reader.onload = (e) => {
                    this.preview = e.target.result;
                };
                this.userFile = event.target.files[0];
                var file = event.target.files[0];
                var img_type = file.name.split(".");
                if (img_type[1] != "jpg" && img_type[1] != "jpeg" && img_type[1] != "png"){
                this.$errorToast("Allowed only jpg, jpeg or png files", {
                    icon: "error",
                });
                return;
                } else if (file.size > 5242880) {
                    this.$errorToast("Image should less than 5Mb", { icon: "error" });
                    return;
                }
                this.selectedImage = URL.createObjectURL(file);
                reader.readAsDataURL(input.files[0]);
                this.readOnlyField = true;
                this.userFileName = file.name;
                this.$nextTick().then(()=>{
                    if(document.getElementById("image-preview")){
                        document.getElementById("image-preview").style.display = "block";
                    }
                });
            }
        },
        closePreview() {
            this.userFileName = "";
            this.isTextMessage = false;
            this.$nextTick().then(()=>{
                if(document.getElementById("image-preview")){
                    document.getElementById("image-preview").style.display = "none";
                }
            });
            this.readOnlyField = false;
        },
        checkMessageText() {
            this.isTextMessage = true;
            if (this.message == "") {
                this.isTextMessage = false;
            }
        },
        editMessage(data, index) {
            this.isEditing = true;
            this.editMessageData = data;
            this.message = data.message;
            this.editMessageIndex = index;
        },
        checkMessageEdit() {
            if (this.message == "") {
            this.isEditing = false;
            } else {
            this.cancelEditing = false;
            }
        },
        cancelEdit() {
            this.isEditing = false;
            this.message = "";
        },
        handlerFunction(stream) {
            this.rec = new MediaRecorder(stream);
            let audioChunks = [];
            this.rec.ondataavailable = (e) => {
                audioChunks.push(e.data);
                if (this.rec.state == "inactive") {
                    let blob = new Blob(audioChunks, { type: "audio/mp3" });
                    recordedAudio.src = URL.createObjectURL(blob);
                    recordedAudio.controls = true;
                    recordedAudio.autoplay = true;
                    this.sendData(blob);
                }
            };
        },
        sendData(blob) {
            this.userFile = blob;
            this.userFileName = "audio-record";
        },
        sendMessage(){
            if (this.message == "" && this.userFileName == "") {
                return false;
            }
            var messageFile;
            const formData = new FormData();
            if (this.message == "") {
                let message = this.userFile;
                if(this.userFile === undefined){
                this.userFileName = "";
                this.$nextTick().then(()=>{
                    if(document.getElementById("image-preview")){
                        document.getElementById("image-preview").style.display = "none";
                    }
                });
                return;
                }
                formData.append("file", message);
            } else {
                let message = this.message;
                formData.append("message", message);
            }
            this.isSending = true;
            this.isSendDisabled = true;
            this.$apiCall('post', 'SEND_CHAT_MESSAGE', formData).then(response => {
                if (response?.status == 200) {
                    if (response?.data?.error) {
                        this.$errorToast(response.data.error);
                    }
                    else {
                        let {created_at, from_user, is_file, message, seen_at, to_user, _id} = response.data.data;
                        this.chatList.push({created_at, from_user, is_file, message, seen_at, to_user, _id});
                        this.closePreview()
                        this.scrollToBottom();
                        this.message = "";
                        this.readOnlyField = false;
                        this.isSending = false;
                        this.isSendDisabled = true;
                    }
                }
            }).catch(error => {
                this.isSending = false;
                if (error) {
                    this.$errorToast(error[0]);
                }
            });
        },
        deleteMessage(chatData, index){
            let data = {
                id: chatData._id
            }
            this.$apiCall('post', 'DELETE_MESSAGE', data).then(response => {
                if (response?.status == 200) {
                    if (response?.data?.error) {
                        this.$errorToast(response.data.error);
                    }
                    else {
                        this.$successToast(response.data.message);
                    }
                }
            }).catch(error => {
                this.isSending = false;
                if (error) {
                    this.$errorToast(error[0]);
                }
            });
        },
        sendEditMessage(){
            let data = {
                id: this.editMessageData._id,
                message: this.message,
            }
            this.$apiCall('post', 'SEND_EDIT_MESSAGE', data).then(response => {
                if (response?.status == 200) {
                    if (response?.data?.error) {
                        this.$errorToast(response.data.error);
                    }
                    else {
                        this.isSending = false;
                        this.isEditing = false;
                        this.message = "";
                    }
                }
            }).catch(error => {
                this.isSending = false;
                if (error) {
                    this.$errorToast(error[0]);
                }
            });
        },
        groupByDate(date) {
            const currentDate = new Date(date);

            const day = String(currentDate.getDate()).padStart(2, '0');
            const month = String(currentDate.getMonth() + 1).padStart(2, '0');
            const year = currentDate.getFullYear();

            const formattedDate = `${day}-${month}-${year}`;
            if (this.tempChatDate !== currentDate.getDate()) {
                this.tempChatDate = currentDate.getDate();
                return formattedDate;
            } else {
                return ''; // Return empty if the day hasn't changed
            }
        },

    }

}
</script>

<style>
.chat-list-container {
    margin-bottom: 2rem !important;
}
</style>